import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { ICourse, ICourseResponse } from 'stores/courses'
import { convertCaseList, ConvertType } from 'utils/convertString'

export const fetchKlassCategoryItemsList = async (
  type: string,
  category: string,
  sort: string = '-order',
  page: number = 1,
  perPage: number = 10,
) => {
  const res = await axios.get<IListDataResp<ICourseResponse>>(
    `${window.apiEndpoint}/course/v1/category/course?type=${type}&category=${category}&is_visible=true&sort=${sort}&page=${page}&per_page=${perPage}`,
  )
  return convertCaseList(res.data, ConvertType.CAMEL) as IListDataConvertResp<ICourse>
}

// 페이별 페이지네이션
export const useKlassCategoryItemsListQuery = (
  type: string,
  category: string,
  sort: string = '-order',
  page?: number,
  perPage?: number,
) => {
  return useQuery({
    queryKey: ['category-items', type, category, sort, page, perPage],
    queryFn: () => fetchKlassCategoryItemsList(type, category, sort, page, perPage),
  })
}

// 무한스크롤 페이지네이션
export const useInfiniteKlassCategoryItemsListQuery = (
  type: string,
  category: string,
  sort: string = '-order',
  perPage: number,
) => {
  return useInfiniteQuery({
    queryKey: ['infinite-category-items', type, category, sort],
    queryFn: ({ pageParam = 1 }) =>
      fetchKlassCategoryItemsList(type, category, sort, pageParam, perPage),
    getNextPageParam: list => {
      if (list.pagination.page < list.pagination.totalPage) {
        return list.pagination.page + 1
      }
      return undefined
    },
  })
}
